import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { HeaderSkeleton } from 'site-modules/personalized-search/components/header-content/header-skeleton/header-skeleton';
import { VerdictSkeleton } from 'site-modules/personalized-search/components/verdict/verdict-skeleton/verdict-skeleton';
import { OpinionSkeleton } from 'site-modules/personalized-search/components/opinion/opinion-skeleton/opinion-skeleton';
import { HighlightsSkeleton } from 'site-modules/personalized-search/components/higlights/highlights-skeleton/highlights-skeleton';
import { LearnMoreSkeleton } from 'site-modules/personalized-search/components/learn-more/learn-more-skeleton/learn-more-skeleton';
import { ExtractSkeleton } from 'site-modules/personalized-search/components/extract/extract-skeleton/extract-skeleton';

import './overview-skeleton.scss';

export const OverviewSkeleton = memo(({ isMobile = false }) => (
  <div className="overview-skeleton base-inner-width px-1 px-md-0_5 px-lg-0 mx-md-auto pb-1 pb-md-2">
    <div className="pos-r">
      <HeaderSkeleton withCtaSkeleton={!isMobile} />
      <VerdictSkeleton />
      <ExtractSkeleton />
      <OpinionSkeleton />
      <HighlightsSkeleton />
      <LearnMoreSkeleton />
    </div>
  </div>
));

OverviewSkeleton.dsplayName = 'OverviewSkeleton';
OverviewSkeleton.propTypes = {
  isMobile: PropTypes.bool,
};
